<template lang="pug">
.re-reset-password.gmh-reset-password(:class="getComponentClasses()")
  .re-container-form(v-if="!success")
    .re-form-head
      h2.box-form-title(v-if="showTitle") {{ title }}
      p.box-form-head-message(v-if="showNotice" v-html="notice")
      p.box-form-head-error(v-show="!!formErrorMessage" v-html="formErrorMessage")
    .re-form-body(:class="{disabled: isBeingProcessed}")
      .re-inp-box.re-inp-box--with-icon
        re-input(
          v-model.trim="$v.fields.password.$model"
          v-bind="getFieldProps('password', {type: 'password', defaults: {label: this.passwordLabel}})"
          :type="showPassword ? 'text' : 'password'"
        )
        re-input-eye-icon(v-model="showPassword")
      .re-inp-box.re-inp-box--with-icon
        re-input(
          v-model.trim="$v.fields.password_confirmation.$model"
          v-bind="getFieldProps('password_confirmation', {type: 'password', defaults: {label: this.passwordConfirmationLabel}})"
          :type="showConfirmPassword ? 'text' : 'password'"
        )
        re-input-eye-icon(v-model="showConfirmPassword")
      .re-submit-button-container
        re-button.re-submit-button(
          @click="initReset"
          :classes="submitButtonClasses || 'reset-password-submit'"
          :tabindex="getMaxFieldOrder()"
          :loading="isPromising"
        ) {{ submitButtonTitle }}
    .re-form-footer
  template(v-else)
    re-toggle-component(:eval="showSuccessPopup" :no-close-button="true")
      .re-password-changed(v-if="showSuccessMessage")
        .re-password-changed__icon
          img(src="/images/client/got-me-hookd/register-success-icon.svg" alt="")
        .re-password-changed__title Success!
        .re-password-changed__message Your password has been changed.
        .re-submit-button-container
          router-link.re-button.login-button.btn(:to="{ name: 'login-page' }") Log In

</template>

<script>
import ReResetPassword from 'utils/vue/components/complex/user/re-reset-password/script.js'

export default {
    name: 'gmh-reset-password',
    mixins: [
        ReResetPassword,
    ],
    data() {
        return {
            showPassword: false,
            showConfirmPassword: false,
            messagePath: 'Please, Sign In with the new password',
        }
    },
}
</script>
